var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultiChoice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.889 13a3.889 3.889 0 11-7.778 0 3.889 3.889 0 017.778 0zM25 13a5 5 0 11-10 0 5 5 0 0110 0zm-5 2.778a2.778 2.778 0 100-5.556 2.778 2.778 0 000 5.556zM23.889 27a3.889 3.889 0 11-7.778 0 3.889 3.889 0 017.778 0zM25 27a5 5 0 11-10 0 5 5 0 0110 0zm-5 2.778a2.778 2.778 0 100-5.556 2.778 2.778 0 000 5.556z",
    fill: "var(--iconColorPrimary, #235CEE)"
  })));
}
export default SvgMultiChoice;